export const validateEmail = (email: string) => {
  const emailRegexValidation =
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegexValidation.test(email);
};
